export function handleErrors(formName, fieldName, vueObj) {
  const errors = [];
  if (!vueObj.$v[formName][fieldName].$dirty) return errors;
  if ("integer" in vueObj.$v[formName][fieldName]) {
    !vueObj.$v[formName][fieldName].integer &&
      errors.push("No decimals. Must be a positive integer");
  }
  if ("required" in vueObj.$v[formName][fieldName]) {
    !vueObj.$v[formName][fieldName].required &&
      errors.push("You gotta put something here!");
  }
  if ("minLength" in vueObj.$v[formName][fieldName]) {
    let minChars = vueObj.$v[formName][fieldName].$params.minLength.min;
    !vueObj.$v[formName][fieldName].minLength &&
      errors.push("This needs at least " + minChars + " characters");
  }
  if ("maxLength" in vueObj.$v[formName][fieldName]) {
    let maxChars = vueObj.$v[formName][fieldName].$params.maxLength.max;
    !vueObj.$v[formName][fieldName].maxLength &&
      errors.push("FOUL! No more than " + maxChars + " characters");
  }
  if ("decimal" in vueObj.$v[formName][fieldName]) {
    !vueObj.$v[formName][fieldName].decimal &&
      errors.push("You can't be using letters!");
  }
  if ("url" in vueObj.$v[formName][fieldName]) {
    !vueObj.$v[formName][fieldName].url && errors.push("This has to be a url");
  }
  if ("maxValue" in vueObj.$v[formName][fieldName]) {
    !vueObj.$v[formName][fieldName].minValue &&
      errors.push("Your value needs to be higher");
  }
  return errors;
}
